export enum FeatureFlags {
  ContentLibraryRouteEnabled = 44839,
  IsReviewsEnabled = 56_033,
}

export enum FeaftureFlags_V2 {
  IsUnifiedUploaderEnabled = 'ENABLE_UNIFIED_UPLOADER',
  IsUrsaEnabled = 'ENABLE_CONTENT_LIBRARY_URSA',
}
